import React from "react";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const CircleWithTick = ({ circleColor = "blue", tickColor = "white" }) => {
  return (
    <Box
      sx={{
        width: "40px",
        height: "40px",
        backgroundColor: circleColor,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CheckIcon sx={{ color: tickColor, fontSize: "32px !important" }} />
    </Box>
  );
};

export default CircleWithTick;
